<div class="mt-4" id="advice-result">
  <h2>{{resources.suggestionHeader}}</h2>
  <div class="conclusion">
    <div [id]="suggestion.id">
      <div [innerHTML]="suggestionText"></div>
    </div>

    @if (suggestion.hasDisclaimer) {
      <ngf-feedback [messages]="disclaimerMessages" [ngClass]="'disclaimer'">
      </ngf-feedback>
    }
  </div>
</div>